import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBelow45FMAY: typeof valueTypeRenderers.chillCumulativeHoursBelow45FMAY = {
  label: () => unitConverter.chillCumulativeHoursBelow45FMAY().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativeHoursBelow45FMAY().title(),
      render: (n) => unitConverter.chillCumulativeHoursBelow45FMAY(n).valueAsString(),
    }),
}
